export default "__VITE_ASSET__7e06181d__"